module.exports = __webpack_public_path__ + "files/882a44338edd6f931b9751bb66dc7205.png";